import React from 'react';
import './countBox.less';

const CountBox = (props) => {
  return <div className="countBox">{props.count}</div>;
};
export default CountBox;
